import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_32.module.css";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter33.json";
import Common_html from "./Common_html";

export default function Chapter_33() {
  //   const corosalref = useRef()

  //   useEffect(()=>{
  //     if(corosalref.current)
  //     {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent",corosalref.current);
  // },[corosalref.current])
  return (
    <>
      <Head>
        <title>A MULTIVERSE CAUSAL DIAMOND | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXXIII"
        ></meta>
        <meta
          property="og:title"
          content="A MULTIVERSE CAUSAL DIAMOND | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An intricate geometric design representing the Multiverse Causal Diamond, showcasing interconnected patterns and dimensional layers. The image illustrates the complex web of cause and effect across multiple realities, symbolizing the divine structure underlying the multiverse."></meta>
        <meta
          property="og:description"
          content="Explore the concept of the Multiverse Causal Diamond in the Central Doctrine, where intricate patterns of cause and effect unfold across multiple realities. Delve into how this multi-dimensional framework reveals the interconnectedness of all existence and the divine influence shaping our multiverse."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=33"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An intricate geometric design representing the Multiverse Causal Diamond, showcasing interconnected patterns and dimensional layers. The image illustrates the complex web of cause and effect across multiple realities, symbolizing the divine structure underlying the multiverse."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=33"></meta>
        <meta name="twitter:title" content="A MULTIVERSE CAUSAL DIAMOND | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Explore the concept of the Multiverse Causal Diamond in the Central Doctrine, where intricate patterns of cause and effect unfold across multiple realities. Delve into how this multi-dimensional framework reveals the interconnectedness of all existence and the divine influence shaping our multiverse."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=33" />
      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}
